import styled from "styled-components";
import * as Layout from "common/layout";
import { Row as AntRow, Button as AntButton } from "antd";

const { Section: AntSection } = Layout;

export const Section = styled(AntSection)`
  font-size: 16px;
  font-weight: bold;
  color: #282828;
`;

export const Row = styled(AntRow)`
  padding-top: 17px;
  padding-bottom: 15px;
  border-bottom: 2px solid #282828;
  &:first-child {
    border-top: 2px solid #282828;
  }
`;

export const Button = styled(AntButton)`
  font-size: 18px;
  letter-spacing: 0.45px;
  font-weight: bold;
`;

export const InfoText = styled.p`
  font-size: 14px;
  color: #777;
  font-weight: normal;
`;
